import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';
import jarallax from 'jarallax/dist/jarallax.js';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.js';

$ = jQuery;

const navigator = document.querySelector("nav");
const navbtn = document.querySelector('.nav-btn');
const close = document.querySelector(".close-menu"); 
const out = document.querySelector("main");

navbtn.addEventListener("click", function(){
    navigator.classList.add('show');
});

close.addEventListener("click", function(){
    navigator.classList.remove('show');
});

out.addEventListener("click", function(){
    navigator.classList.remove('show');
});


const header = document.querySelector("header");

window.addEventListener('scroll', () => (window.scrollY > 200) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header')  );

window.addEventListener('resize', function(){
    document.querySelector("nav").classList.remove('show');
});


let segundoNivel = document.querySelectorAll("header nav ul li ul li");

segundoNivel.forEach(item => {

  item.addEventListener("click", function(e){

    // ✅ Si el click viene de un <a>, lo dejamos pasar
    if(e.target.tagName === "A") return;

    let tercerNivel = item.querySelector(":scope > ul");

    if(!tercerNivel) return;

    e.preventDefault();

    segundoNivel.forEach(li => {
      let sub = li.querySelector(":scope > ul");
      if(sub && li !== item){
        sub.classList.remove("open");
      }
    });

    tercerNivel.classList.toggle("open");

  });

});

AOS.init({
    once: true,
});

jarallax(document.querySelectorAll('[data-jarallax]'));


document.addEventListener("mousemove", (e) => {

  const x = (e.clientX / window.innerWidth) * 100;
  const y = (e.clientY / window.innerHeight) * 100;

  document.documentElement.style.setProperty("--x", x + "%");
  document.documentElement.style.setProperty("--y", y + "%");

});








document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("homepage-skeleton");
  if (!wrapper) return;

  const images = wrapper.querySelectorAll("img");
  let loadedCount = 0;
  let totalImages = images.length;

  function finishLoading() {
    wrapper.classList.remove("is-loading");
    wrapper.classList.add("is-loaded");
  }

  if (totalImages === 0) {
    setTimeout(finishLoading, 1000);
    return;
  }

  function imageDone() {
    loadedCount++;
    if (loadedCount >= totalImages) {
      setTimeout(finishLoading, 1000);
    }
  }

  images.forEach((img) => {
    if (img.complete) {
      imageDone();
    } else {
      img.addEventListener("load", imageDone, { once: true });
      img.addEventListener("error", imageDone, { once: true });
    }
  });

  window.addEventListener("load", function () {
    setTimeout(finishLoading, 1000);
  });
});



// const listaDeActivosOptions = document.getElementById('categorias-de-activos');
// const activosCards = document.querySelectorAll('.activos-card');

// const activosSearch = document.getElementById('activosSearch');
// const contentActivos = document.querySelector('.container-activos');
// const activosGrid = document.getElementById('activosGrid');

// // Helpers para alternar vistas
// function showActivos() {
//   activosGrid.classList.add('show');
//   activosGrid.classList.remove('hidden');

//   contentActivos.classList.add('hidden');
//   contentActivos.classList.remove('show');
// }

// function showActivos() {
//   contentActivos.classList.add('show');
//   contentActivos.classList.remove('hidden');

//   activosGrid.classList.add('hidden');
//   activosGrid.classList.remove('show');
// }

// // 🔎 Cuando escribo en el buscador
// activosSearch.addEventListener('input', function () {
//   if (this.value.trim() !== '') {
//     // Resetear select
//     listaDeActivosOptions.value = 'todos';

//     // Mostrar productos
//     showActivos();
//   } else {
//     showActivos();

//     // Opcional: aquí también podrías ocultarlo si vacío no debe mostrar no-results
//     // if (noResults) noResults.style.display = 'none';
//   }
// });

// // 📂 Cuando cambio categoría
// listaDeActivosOptions.addEventListener('change', function () {

//   // Resetear buscador
//   activosSearch.value = '';

//   showActivos();

//   const value = this.value;

//   activosCards.forEach(card => {
//     if (value === 'todos') {
//       card.style.display = 'flex';
//       return;
//     }

//     const terms = (card.getAttribute('data-terms') || '')
//       .split(/\s+/)
//       .filter(Boolean);

//     card.style.display = terms.includes(value) ? 'flex' : 'none';
//   });

//   refreshAOS();
// });




// document.addEventListener('DOMContentLoaded', function () {
//   const filters = document.querySelectorAll('.js-filter');
//   const cards = document.querySelectorAll('.activo-card');
//   const clearBtn = document.getElementById('clearFilters');
//   const noResults = document.getElementById('noResults');

//   function getCheckedValues(taxonomy) {
//     return Array.from(document.querySelectorAll(`.js-filter[data-taxonomy="${taxonomy}"]:checked`))
//       .map(input => input.value);
//   }

//   function cardMatches(card, selectedValues, dataAttr) {
//     // Si no hay filtros seleccionados para esta taxonomía, pasa automáticamente
//     if (!selectedValues.length) return true;

//     const cardValues = (card.getAttribute(dataAttr) || '')
//       .split(/\s+/)
//       .filter(Boolean);

//     // OR dentro de la misma taxonomía
//     return selectedValues.some(value => cardValues.includes(value));
//   }

//   function applyFilters() {
//     const selectedTipos = getCheckedValues('tipo');
//     const selectedCiudades = getCheckedValues('ciudad');
//     const selectedEspecificaciones = getCheckedValues('especificacion');

//     let visibleCount = 0;

//     cards.forEach(card => {
//       const matchTipo = cardMatches(card, selectedTipos, 'data-tipo');
//       const matchCiudad = cardMatches(card, selectedCiudades, 'data-ciudad');
//       const matchEspecificacion = cardMatches(card, selectedEspecificaciones, 'data-especificacion');

//       // AND entre taxonomías
//       const shouldShow = matchTipo && matchCiudad && matchEspecificacion;

//       if (shouldShow) {
//         card.style.display = '';
//         visibleCount++;
//       } else {
//         card.style.display = 'none';
//       }
//     });

//     if (noResults) {
//       noResults.style.display = visibleCount ? 'none' : 'block';
//     }
//   }

//   filters.forEach(filter => {
//     filter.addEventListener('change', applyFilters);
//   });

//   if (clearBtn) {
//     clearBtn.addEventListener('click', function () {
//       filters.forEach(filter => {
//         filter.checked = false;
//       });
//       applyFilters();
//     });
//   }

//   applyFilters();
// });


document.addEventListener('DOMContentLoaded', function () {
  const filters = document.querySelectorAll('.js-filter');
  const cards = document.querySelectorAll('.activo-card');
  const clearBtn = document.getElementById('clearFilters');
  const noResults = document.getElementById('noResults');

  function getCheckedValues(taxonomy) {
    return Array.from(
      document.querySelectorAll(`.js-filter[data-taxonomy="${taxonomy}"]:checked`)
    ).map(input => input.value);
  }

  function cardMatches(card, selectedValues, dataAttr) {
    // Si no hay filtros activos en esta taxonomía, no suma coincidencia
    if (!selectedValues.length) return false;

    const cardValues = (card.getAttribute(dataAttr) || '')
      .split(/\s+/)
      .filter(Boolean);

    // OR dentro de la misma taxonomía
    return selectedValues.some(value => cardValues.includes(value));
  }

  function applyFilters() {
    const selectedTipos = getCheckedValues('categoria');
    const selectedCiudades = getCheckedValues('departamento');
    const selectedEspecificaciones = getCheckedValues('especificacion');

    const hasActiveFilters =
      selectedTipos.length ||
      selectedCiudades.length ||
      selectedEspecificaciones.length;

    let visibleCount = 0;

    cards.forEach(card => {
      const matchTipo = cardMatches(card, selectedTipos, 'data-tipo');
      const matchCiudad = cardMatches(card, selectedCiudades, 'data-ciudad');
      const matchEspecificacion = cardMatches(card, selectedEspecificaciones, 'data-especificacion');

      // OR global entre taxonomías
      const shouldShow = !hasActiveFilters || matchTipo || matchCiudad || matchEspecificacion;

      if (shouldShow) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    if (noResults) {
      noResults.style.display = visibleCount ? 'none' : 'block';
    }
  }

  function applyFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
  
    const taxonomyMap = {
      'categoria': 'categoria',
      'departamento': 'departamento',
    };
  
    Object.entries(taxonomyMap).forEach(([urlKey, taxonomyKey]) => {
      const paramValue = urlParams.get(urlKey);
  
      if (!paramValue) return;
  
      const values = paramValue
        .split(',')
        .map(v => v.trim())
        .filter(Boolean);
  
      values.forEach(value => {
        const checkbox = document.querySelector(
          `.js-filter[data-taxonomy="${taxonomyKey}"][value="${value}"]`
        );
  
        if (checkbox) {
          checkbox.checked = true;
        }
      });
    });
  }

  filters.forEach(filter => {
    filter.addEventListener('change', applyFilters);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      filters.forEach(filter => {
        filter.checked = false;
      });
      applyFilters();
    });
  }

  // 1. primero leer URL
  applyFiltersFromUrl();

  applyFilters();
});


$('.slider3').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 4000,
  adaptiveHeight: true,
  infinite: true,
  loop: false,
  asNavFor: '.slider-nav'
});

$(".carousel-dots .left3").click( () => {
$(".slider3").slick('slickPrev');
});

$(".carousel-dots .right3").click( () => {
$(".slider3").slick('slickNext');
});


$('.slider-nav').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.slider3',
  infinite: false,
  dots: false,
  centerMode: false,
  arrows: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 2,
      }
    }
  ]

});


Fancybox.bind('.slider3 .slick-slide:not(.slick-cloned) a[data-fancybox="gallery"]', {
  Thumbs: {
    showOnStart: true,
  },
});